export const PROPERTY_CATEGORY = (communityId: string) => `v1/property-categories/community/${communityId}`;
